import { createSelector } from '@reduxjs/toolkit';
import { blobUrlStore } from '@ff-os/rendering-react/asset-loading/blobUrlStore';
import { selectAllProcessedPhotos } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpStore } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';

export const startBlobStoreGarbageCollector = (store: PhotoPrintsPdpStore) => {
    blobUrlStore.startGarbageCollector(() => selectLocalBlobUrls(store.getState()));
};

const selectLocalBlobUrls = createSelector([
    selectAllProcessedPhotos
], photos => {
    return photos
        .filter(p => p.status !== 'saved')
        .map(p => (p as PhotoPrintsJson.ProcessedPhoto).localUrl!);
});